<h1>Operator Notifications</h1>

<div class="messageLog">
	<div *ngFor="let msg of messageLog">
		<li *ngFor="let item of msg.error">
  			<span class={{item.html}}>{{item.message}}</span>
  		</li>
  	</div>
</div>